import LottieIllustration from '../../app/components/lottieIllustration';
import lottieData from '../../../assets/lottie/flag/flag/data.json';

export default class FinishFlagView {
    #el;
    #lottie;
    #hideAnimationDuration = 500;

    constructor(selector, options = {
        hideOnComplete: false
    }) {
        this.#el = document.querySelector(selector);
        this.options = options;

        this.#lottie = new LottieIllustration(this.#el, {
            animationData: lottieData,
            loop: false,
            autoplay: false,
            loopFromFrame: 120
            // loopFromFrame: !this.options.hideOnComplete ? 120 : null
            // onComplete: () => {
            //     this.onAnimationComplete();
            // }
        });
    }

    // onAnimationComplete() {
    //     this.hide();
    // }

    show() {
        this.#el.classList.add('active');

        this.#lottie.play();
    }

    hide() {
        this.#el.classList.remove('active');

        setTimeout(() => {
            this.#lottie.reset();
        }, this.#hideAnimationDuration);
    }
}
